import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function NotFound() {
  const { lang } = useLang();
  const location = useLocation();
  const ar = location.pathname.startsWith("/ar") || (!location.pathname.startsWith("/en") && lang === "ar");

  useEffect(() => {
    document.title = ar ? "الصفحة غير موجودة — 404 | SS Downloader" : "Page not found — 404 | SS Downloader";
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
  }, [ar]);

  return (
    <main
      data-testid="not-found-page"
      className="flex min-h-screen flex-col items-center justify-center bg-void px-6 text-center"
      dir={ar ? "rtl" : "ltr"}
    >
      <p className="font-display text-[7rem] font-black leading-none neon-text-gradient">404</p>
      <h1 className="mt-4 text-2xl font-black text-ice">
        {ar ? "هذه الصفحة غير موجودة" : "This page does not exist"}
      </h1>
      <p className="mt-3 max-w-md text-sm text-muted-foreground leading-relaxed">
        {ar
          ? "الرابط الذي فتحته غير صحيح أو انتقلت الصفحة. يمكنك العودة للرئيسية وتحميل فيديوهاتك من هناك."
          : "The link you opened is incorrect or the page has moved. Head back home to download your videos."}
      </p>
      <Link
        to={ar ? "/" : "/en/"}
        data-testid="not-found-home-btn"
        className="btn-neon mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 font-bold"
      >
        <Compass className="h-4 w-4" />
        {ar ? "العودة للرئيسية" : "Back to homepage"}
      </Link>
    </main>
  );
}
